import { StepsDefinitionsAll } from '@/components/modules/Funnel/constants/StepsDefinitionsAll';
import { StepsDefinitionsLoan } from '@/components/modules/Funnel/constants/StepsDefinitionsLoan';
import { StepsDefinitionsOrder } from '@/components/modules/Funnel/constants/StepsDefinitionsOrder';
import { ProductType } from '@/components/modules/Funnel/types/ProductType';

export const getStepsDefinitions = (productType: ProductType) => {
  switch (productType) {
    case ProductType.LOAN:
      return StepsDefinitionsLoan;
    case ProductType.ORDER:
      return StepsDefinitionsOrder;
    case ProductType.ALL:
    default:
      return StepsDefinitionsAll;
  }
};
